import { TLCEvents } from "../../../js/lib/events/events";

/**
 * @deprecated
 */
export const EventableMixin = function() {
	this.events = [];
	this.removeListenerFunctions = [];
	this.addEvents = function() {
		for( var i = 0, len = this.events.length; i < len; i += 1 ) {
			var eventString = this.events[i];
			const guid = TLCEvents.on( eventString, this[eventString], this );
			this.removeListenerFunctions.push(()=>{TLCEvents.off(eventString, guid)})
		}
	}
};

